import Konva from "konva";
import html2canvas from "html2canvas";
import { DMCText } from "../KObjects/DMCText";

// TOOLS
const rectangleTool = require("./RectangleTool");

export class Text extends rectangleTool.Rectangle {
  constructor() {
    super();
    this.name = "Text";
    this.text = "";
    this.edit = "";
  }

  createControllerObject(name, konvaObject) {
    return new DMCText(name, konvaObject, this.text);
  }

  createNew(controllerProject) {
    super.createNew(controllerProject);
  }

  createNewForm() {
    const currentImage = new Konva.Image(this.currentShapeConfig);
    currentImage.fill(null);
    const textDiv = this.createTextElement(this.text);

    html2canvas(textDiv, {
      backgroundColor: null,
    })
      .then((canvas) => {
        currentImage.width(canvas.width);
        currentImage.height(canvas.height);
        currentImage.image(canvas);

        textDiv.remove();
      })
      .catch((err) => {
        console.error(err);
      });

    return currentImage;
  }

  /**
   * Create the DOM element that will be rendered
   * @param {String} htmlText
   * @returns DOM element
   */
  createTextElement(htmlText) {
    // Retrieve rendering element
    const element = document.getElementById("textRenderingToCanvas");

    if (element !== null) {
      const div = document.createElement("div");

      div.innerHTML = htmlText;
      div.style.color = this.color;

      element.appendChild(div);

      return div;
    } else {
      return null;
    }
  }

  defaultText() {
    let tempDiv = document.createElement("div");
    tempDiv.innerHTML = this.text;
    let element = document.getElementById("textRenderingToCanvas");
    element.appendChild(tempDiv);
    return tempDiv;
  }

  mouseDown(controllerProject) {
    this.createNew(controllerProject);
    let origin = {};
    origin.x = controllerProject.collectCurrentMousePosition().x / controllerProject.scale;
    origin.y = controllerProject.collectCurrentMousePosition().y / controllerProject.scale;
    this.currentObject.setAttr("x", origin.x);
    this.currentObject.setAttr("y", origin.y);
  }

  mouseUp(controllerProject) {
    //controllerProject.currentElement = this.currentObject;
    const name = controllerProject.addNewObjectToCurrentLayer(this.currentObject, this.name, this);

    try {
      controllerProject.stage.draw();
    } catch (err) {
      console.error(err);
    }

    this.currentOptions = this.resetOptions;
    return name;
  }

  removeAllChildFromDOMElement(DOMElementName) {
    let element = document.getElementById(DOMElementName);
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }

  setText(text) {
    this.text = text;
  }

  setContent(text, name) {
    this.name = name;
    this.setText(text);
  }

  setConfig(edit) {
    this.edit = edit;
  }

  editNewElement(controllerProject) {
    this.createNew(controllerProject);
    this.currentObject.setAttr("x", this.edit.x);
    this.currentObject.setAttr("y", this.edit.y);
    this.currentObject.setAttr("width", this.edit.width);
    this.currentObject.setAttr("height", this.edit.height);
    this.currentObject.setAttr("scaleX", this.edit.scaleX);
    this.currentObject.setAttr("scaleY", this.edit.scaleY);
    this.edit = "";
    return this.mouseUp(controllerProject);
  }
}
